module.exports = __webpack_public_path__ + "static/4-c86d83d53d2c8dc88cd5d66e0b5273a1.jpg";